import { render, staticRenderFns } from "./PoultryHouseCard.vue?vue&type=template&id=a77c2d7c&scoped=true&"
import script from "./PoultryHouseCard.vue?vue&type=script&lang=js&"
export * from "./PoultryHouseCard.vue?vue&type=script&lang=js&"
import style0 from "./PoultryHouseCard.vue?vue&type=style&index=0&id=a77c2d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77c2d7c",
  null
  
)

export default component.exports